import React from "react";
import {Box, Shimmer, View} from "@unibuddy/patron";
import {ChatContainer, ChatInput, MessageBubbleDesktop, MessageRow} from "@unibuddy/chat-ui";

import {ChatFooter} from "./ChatFooter/ChatFooter";
import {chatTheme} from "../../../utils/theme/chatTheme";

export const ChatLoadingMessages = () => {
    return (
        <ChatContainer>
            <View
                paddingX="xsmall"
                paddingTop="small-medium"
                height="100%"
                bgColor={chatTheme.chat.scroll.backgroundColor}
            >
                <MessageRow align="left" position="orphan">
                    <MessageBubbleDesktop align="left" position="orphan">
                        <Box width="200px" height="64px">
                            <Shimmer aria-hidden="true">
                                <rect x="0" y="0" rx="4" ry="4" width="200" height="16" />
                                <rect x="0" y="24" rx="4" ry="4" width="200" height="16" />
                                <rect x="0" y="48" rx="4" ry="4" width="100" height="16" />
                            </Shimmer>
                        </Box>
                    </MessageBubbleDesktop>
                </MessageRow>
            </View>

            <ChatFooter>
                <ChatInput
                    onSend={() => {
                        return;
                    }}
                    disabled={true}
                />
            </ChatFooter>
        </ChatContainer>
    );
};
